class LoadMoreComponent extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('[data-ref="load-more-btn"]');
        this.nextUrl = this.dataset.nextUrl;
        this.isLoading = false;
    }

    connectedCallback() {
        if (this.button) {
            this.button.addEventListener('click', this.loadMore.bind(this));
        }
    }

    async loadMore(event) {
        if (event) event.preventDefault();
        if (this.isLoading || !this.nextUrl) return;

        this.isLoading = true;
        this.button.classList.add('is-loading');

        const gridSelector = '[data-ref="main-collection-grid"]';
        const currentGrid = document.querySelector(gridSelector);

        // Add skeleton items
        if (currentGrid) {
            for (let i = 0; i < 4; i++) {
                const skeleton = document.createElement('div');
                skeleton.className = 'product-card-skeleton';
                skeleton.innerHTML = '<div class="skeleton-image"></div><div class="skeleton-text"></div><div class="skeleton-text short"></div>';
                currentGrid.appendChild(skeleton);
            }
        }

        try {
            const response = await fetch(this.nextUrl);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newGrid = doc.querySelector(gridSelector);

            if (newGrid && currentGrid) {
                // Append new items
                const newItems = Array.from(newGrid.children);
                newItems.forEach(item => {
                    currentGrid.appendChild(item);
                });

                // Update load more button
                const newLoadMore = doc.querySelector('load-more-component');
                if (newLoadMore && newLoadMore.dataset.nextUrl) {
                    this.nextUrl = newLoadMore.dataset.nextUrl;
                    this.dataset.nextUrl = this.nextUrl;
                } else {
                    // No more pages
                    this.remove();
                }
            }
        } catch (error) {
            console.error('Error loading more items:', error);
        } finally {
            if (currentGrid) {
                currentGrid.querySelectorAll('.product-card-skeleton').forEach(el => el.remove());
            }
            if (this.button) {
                this.button.classList.remove('is-loading');
            }
            this.isLoading = false;
        }
    }
}

customElements.define('load-more-component', LoadMoreComponent);
